import React from "react";
import { useTranslation } from "react-i18next";
import { MoneyApi } from "go-core/api/types";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import OrderTipTipsItem from "./OrderTipTipsItem";

interface Props {
	totalPrice: MoneyApi;
}

const OrderTipTips = ({ totalPrice }: Props) => {
	const { t } = useTranslation();

	const getTips = () => {
		const tips: { tipAmount: number | null; title: string; description?: string }[] = [
			{ tipAmount: 0, title: t("modules.e_order.field.without_tip.title") },
		];
		const totalPriceAmount = totalPrice.amount;

		for (let i = 10; i <= 20; i += 5) {
			const tipAmount = Number((totalPriceAmount * (i / 100)).toFixed(2));
			tips.push({
				tipAmount,
				description: `${i}%`,
				title: FormatMoney({ amount: tipAmount, currency: totalPrice.currency }),
			});
		}

		tips.push({
			tipAmount: null,
			title: t("modules.e_order.field.other_tip_amount.title"),
			description: t("lib:common.action.select"),
		});

		return tips;
	};

	return (
		<section data-testid="e-order-tips-section">
			<div className="order-tips">
				{getTips().map((tip, index) => (
					<OrderTipTipsItem
						key={index}
						tipAmount={tip.tipAmount}
						title={tip.title}
						description={tip.description}
					/>
				))}
			</div>
		</section>
	);
};

export default OrderTipTips;
